import { render, staticRenderFns } from "./InstitutionEditor.vue?vue&type=template&id=9c3f3e4e&"
import script from "./InstitutionEditor.vue?vue&type=script&lang=js&"
export * from "./InstitutionEditor.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports